import { isNil } from 'lodash/fp'
import { rem } from 'polished'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, BUTTON_VARIANT } from 'components/Button'
import { Box, Flex, Grid } from 'components/Layout'
import { Review } from 'components/Review'
import { SPACE } from 'Theme'
import { AverageRating } from './AverageRating'

const SEE_MORE_BUTTON_WIDTH = rem(120)

export const ExpertReviews = ({
  reviews,
  reviewsAverageRating,
  nextPage,
  onSeeMore,
  isSeeMoreLoading,
}) => (
  <Box>
    {!isNil(reviewsAverageRating.avg) && (
      <AverageRating
        averageRating={reviewsAverageRating.avg}
        count={reviewsAverageRating.totalCount}
      />
    )}
    <Grid
      gridTemplateColumns={{ MOBILE: 'auto', TABLET: '1fr 1fr' }}
      gridColumnGap={SPACE.PX_30}
    >
      {reviews.map((review) => (
        <Review
          key={review.id}
          feedback={review.feedback}
          name={`${review.client.firstName} ${review.client.lastName}`}
        />
      ))}
    </Grid>
    {nextPage && (
      <Flex width={SEE_MORE_BUTTON_WIDTH} m="auto" mt={SPACE.PX_30}>
        <Button
          isLoading={isSeeMoreLoading}
          variant={BUTTON_VARIANT.OUTLINE}
          mt={SPACE.PX_20}
          onClick={() => {
            onSeeMore()
          }}
        >
          See more
        </Button>
      </Flex>
    )}
  </Box>
)

ExpertReviews.defaultProps = {
  isSeeMoreLoading: false,
}

ExpertReviews.propTypes = {
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      rating: PropTypes.number,
      feedback: PropTypes.string,
      client: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      }),
    })
  ),
  reviewsAverageRating: PropTypes.shape({
    avg: PropTypes.number,
    totalCount: PropTypes.number,
  }),
  nextPage: PropTypes.number,
  onSeeMore: PropTypes.func.isRequired,
  isSeeMoreLoading: PropTypes.bool,
}
